// extracted by mini-css-extract-plugin
export default {"header":"fo","fullPage":"go","closed":"ho","minimize":"io","redcircle":"jo","container":"ko","text":"lo","centered":"mo","escapex":"no"};
    if(module.hot) {
      // 1713912562950
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  